import { useState } from 'react'

import { useLightMode } from '@/hooks/useLightMode'
import { useTranslation } from 'react-i18next'

import {
  Box as DarkBox,
  Modal as DarkModal,
  Tabs as DarkTabs,
} from '@hivewatch/dark'

import { CreateCaseForm } from '@/features/case-crud'

import { AssociateExisitingCaseForm } from './AssociateExisitingCaseForm'

interface AssociateCaseModalIProps {
  incidentId: string
  isOpen: boolean
  onClose: () => void
}

export const AssociateCaseModal = ({
  incidentId,
  isOpen,
  onClose,
}: AssociateCaseModalIProps) => {
  const { t } = useTranslation()
  const colorScheme = useLightMode()
  const [activeTab, setActiveTab] = useState('new')

  const tabItems = [
    { id: 'new', label: t('incidents:new_case') },
    { id: 'existing', label: t('incidents:existing_case') },
  ]
  return (
    <DarkModal
      {...(colorScheme === 'dark' && {
        bodyStyleOverrides: { bg: 'bg.card' },
        headerStyleOverrides: { container: { bg: 'bg.card' } },
      })}
      colorScheme={colorScheme}
      isOpen={isOpen}
      isSaveHidden
      onClose={onClose}
      title={t('incidents:associate_case_title')}
      zIndex={1500}
    >
      <DarkTabs
        activeId={activeTab}
        colorScheme={colorScheme}
        items={tabItems}
        onChange={setActiveTab}
      />
      <DarkBox mt='16px'>
        {activeTab === 'new' ? (
          <CreateCaseForm
            colorScheme={colorScheme}
            incidentId={incidentId}
            isRebrand
            onClose={onClose}
          />
        ) : (
          <AssociateExisitingCaseForm
            colorScheme={colorScheme}
            incidentId={incidentId}
            onClose={onClose}
          />
        )}
      </DarkBox>
    </DarkModal>
  )
}
